// Utility Types
export type Nullable<T, D extends keyof T> = {
  [K in keyof T]: K extends D ? T[K] | null : T[K];
};

export type DeepNullable<T> = {
  [K in keyof T]: T[K] extends object ? DeepNullable<T[K]> | null : T[K] | null;
};

// Constants
export const ID_ALL_TYPE = { id: "IS_ALL", name: "すべて" } as const;

// Basic Types
export type UuidType = `${string}-${string}-${string}-${string}`;
export type EmailType = `${string}@${string}.${string}`;
